import { gql } from '@apollo/client';
import { ADDRESS_FRAGMENT, RestAddress, RestAddressInput } from '../fragments.rest';

export type CreateAddressMutation = {
  createAddress: {
    __typename: 'RestCreateAddress';
    data: RestAddress;
  };
};

export type CreateAddressMutationVariables = {
  input: RestAddressInput;
};

export const CREATE_ADDRESS_MUTATION = gql`
  mutation CreateAddressMutation($input: RestAddressInput) {
    createAddress(input: $input)
      @rest(type: "RestCreateAddress", endpoint: "user", path: "/addresses/", method: "POST") {
      data @type(name: "RestAddress") {
        ...AddressFragment
      }
    }
  }
  ${ADDRESS_FRAGMENT}
`;
